// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"f438d57d","307":"7a934f8a","673":"ec60f688","767":"a444ab01"}[chunkId] + ".chunk.js";
};